import { isNullOrUndefined, isUndefined } from './validators/baseComponentsValidators'

/** @typedef {Record<'INITIAL' | 'DONE' |'LOADING' | 'ERROR' | 'RELOADING' | 'RETRY' | 'UNHANDLED', boolean>} Status */

/** @param {object} CreateStateConfig
  * @param {string} CreateStateConfig.key
  * @param {unknown} CreateStateConfig.initialValue */
export const createState = ({ key, initialValue }) => {
  if (isNullOrUndefined(key)) throw new Error('\'key\' must be passed')
  if (isUndefined(initialValue)) initialValue = null
  // Define the initial state object structure
  const state = {
    data: initialValue,
    isLoading: false,
    error: false,
  }

  // Mutation to set the state with optional parameters
  const setter = (stateObj, { data, isLoading, error, reset } = {}) => {
    if (reset) {
      stateObj[key] = { ...state }
      return
    }

    if (!isUndefined(data)) {
      stateObj[key].data = data
      stateObj[key].error = false
    }
    if (!isUndefined(isLoading)) stateObj[key].isLoading = isLoading
    if (!isUndefined(error)) stateObj[key].error = error
  }

  /** @returns {Status} */
  const status = (state) => {
    const s = state[key]

    const stateMachine = {
      INITIAL: false,
      DONE: false,
      LOADING: false,
      ERROR: false,
      RELOADING: false,
      RETRY: false,
      UNHANDLED: false,
    }

    if (s.data === initialValue && s.isLoading === false && s.error === false) stateMachine.INITIAL = true
    else if (s.data !== initialValue && s.isLoading === false && s.error === false) stateMachine.DONE = true
    else if (s.data === initialValue && s.isLoading === true && s.error === false) stateMachine.LOADING = true
    else if (s.data === initialValue && s.isLoading === false && s.error !== false) stateMachine.ERROR = true
    else if (s.data !== initialValue && s.isLoading === true && s.error === false) stateMachine.RELOADING = true
    else if (s.data === initialValue && s.isLoading === true && s.error !== false) stateMachine.RETRY = true
    else stateMachine.UNHANDLED = true

    return stateMachine
  }

  /** @param {Object} state
    * @param {{ data: unknown, isLoading: boolean, error: unknown }} state[key]
    * @param {Record<string, unknown>} state.*
    * @returns {{ isLoading: boolean, error: unknown, data: unknown, status: Status }}*/

  const getter = (state) => ({
    ...state[key],
    error: state[key].data ? false : state[key].error,
    status: status(state),
  })

  // Return the state function and the mutations
  return { state, setter, getter }
}
